<div class="input-list">
	<div
		*ngFor="let input of inputs.controls; let i = index; trackBy: trackByIndex"
		class="input-wrapper"
		data-test-id="input-wrapper"
	>
		<input
			#inputElement
			(focus)="handleFocus($event)"
			(blur)="handleBlur()"
			(keypress)="handleKeyPress($event, i)"
			(input)="handleInput()"
			(keydown.backspace)="handleBackspaceOrDelete(i)"
			(keydown.delete)="handleBackspaceOrDelete(i)"
			(paste)="handlePaste($event, i)"
			(keydown.arrowleft)="handleArrowLeft(i)"
			(keydown.arrowright)="handleArrowRight(i)"
			(keyup.enter)="submitEnterPress($event)"
			[formControl]="$any(input)"
			[attr.autocomplete]="i === 0 ? 'one-time-code' : null"
			type="text"
			inputmode="numeric"
			data-test-id="otp-input-code"
		/>
	</div>
</div>

<ng-content select="[messages]"> </ng-content>
